import { guides } from "./content.mjs";
const SITE_URL = "https://sphome.vn";
const INDEX = "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1";
const NOINDEX = "noindex, follow";
const pages = [
  { path: "/", title: "Phần mềm quản lý nhà trọ, điện nước và hợp đồng | SP Home", description: "SP Home giúp quản lý phòng trọ, khách thuê, hợp đồng, hóa đơn điện nước và công nợ; kết nối cộng tác viên để tìm khách thuê phòng." },
  { path: "/rooms", title: "Danh sách phòng trọ và nhà cho thuê | SP Home", description: "Xem danh sách phòng trên SP Home, tìm theo khu vực, giá thuê và nhu cầu; xem thông tin chi tiết và đặt lịch xem phòng." },
  { path: "/about", title: "Giới thiệu SP Home và mạng lưới cộng tác viên", description: "Tìm hiểu SP Home, nền tảng quản lý nhà trọ và kết nối cộng tác viên với chủ nhà để giới thiệu phòng cho thuê." },
  { path: "/contact", title: "Liên hệ hỗ trợ quản lý nhà trọ và cộng tác | SP Home", description: "Liên hệ SP Home để tìm hiểu quản lý nhà trọ, hóa đơn, công nợ và quy trình cộng tác cho thuê phòng." },
  ...guides.map(({ path, title, description }) => ({ path, title, description })),
];

function normalizePath(pathname) {
  return pathname.replace(/\/+$/, "") || "/";
}

function canonicalUrl(pathname) {
  const clean = normalizePath(pathname);
  return `${SITE_URL}${clean === "/" ? "/" : `${clean}/`}`;
}

function getPageMeta(pathname) {
  const clean = normalizePath(pathname);
  const page = pages.find((item) => item.path === clean);
  if (page) return { ...page, canonical: canonicalUrl(clean), robots: INDEX };
  if (/^\/room\/[^/]+$/.test(clean)) {
    return { path: clean, title: "Thông tin phòng cho thuê | SP Home", description: "Xem giá thuê, diện tích, tiện ích và đặt lịch xem phòng trên SP Home.", canonical: `${SITE_URL}${clean}`, robots: INDEX };
  }
  // Do not index account pages, demo pages or unknown routes.
  return { path: clean, title: "SP Home", description: "Quản lý nhà trọ và kết nối cộng tác viên cho thuê phòng cùng SP Home.", canonical: null, robots: NOINDEX };
}

function structuredData(meta) {
  if (meta.robots !== INDEX) return null;
  const graph = [
    { "@type": "Organization", "@id": `${SITE_URL}/#organization`, name: "SP Home", url: `${SITE_URL}/`, logo: `${SITE_URL}/icon-logo.png` },
    { "@type": "WebSite", "@id": `${SITE_URL}/#website`, name: "SP Home", url: `${SITE_URL}/`, inLanguage: "vi", publisher: { "@id": `${SITE_URL}/#organization` } },
    { "@type": "WebPage", "@id": `${meta.canonical}#webpage`, url: meta.canonical, name: meta.title, description: meta.description, inLanguage: "vi", isPartOf: { "@id": `${SITE_URL}/#website` } },
  ];
  return { "@context": "https://schema.org", "@graph": graph };
}

export { SITE_URL, INDEX, NOINDEX, pages, normalizePath, canonicalUrl, getPageMeta, structuredData };
export default { SITE_URL, INDEX, NOINDEX, pages, normalizePath, canonicalUrl, getPageMeta, structuredData };
